import { useEffect, useState } from "react";

// Wed(3) Thu(4) Fri(5) Sat(6) Sun(0) · 10:00–19:00 IST
const OPEN_DAYS = new Set([0, 3, 4, 5, 6]);
const OPEN_HOUR = 10;
const CLOSE_HOUR = 19;

function computeIST() {
  const fmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  });
  const parts = fmt.formatToParts(new Date()).reduce((a, p) => (a[p.type] = p.value, a), {});
  const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const day = dayMap[parts.weekday] ?? 0;
  const h = Number(parts.hour);
  const m = Number(parts.minute);
  return { day, h, m };
}

function nextOpenLabel(day) {
  const names = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  for (let i = 1; i <= 7; i++) {
    const d = (day + i) % 7;
    if (OPEN_DAYS.has(d)) return names[d];
  }
  return "";
}

export default function OpenBadge({ className = "" }) {
  const [state, setState] = useState(() => computeIST());

  useEffect(() => {
    const id = setInterval(() => setState(computeIST()), 60_000);
    return () => clearInterval(id);
  }, []);

  const { day, h, m } = state;
  const openNow = OPEN_DAYS.has(day) && h >= OPEN_HOUR && (h < CLOSE_HOUR || (h === CLOSE_HOUR && m === 0));
  const closingSoon = openNow && h === CLOSE_HOUR - 1;

  let label;
  if (openNow) {
    label = closingSoon ? "Closing soon" : "Open now";
  } else if (OPEN_DAYS.has(day) && h < OPEN_HOUR) {
    label = "Opens 10 AM";
  } else {
    label = `Closed · Opens ${nextOpenLabel(day)}`;
  }

  return (
    <span
      className={`inline-flex items-center gap-2 text-[11px] tracking-widest uppercase ${className}`}
      data-testid="open-badge"
      title="Wed–Sun · 10 AM – 7 PM IST"
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ background: openNow ? "#4A5D4E" : "#B0AEA6", boxShadow: openNow ? "0 0 0 3px rgba(74,93,78,0.18)" : "none" }}
      />
      {label}
    </span>
  );
}
